"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var widgets_1 = require("@phosphor/widgets");
/**
 * The class name added to an editor widget that has a primary selection.
 */


var HAS_SELECTION_CLASS = 'jp-mod-has-primary-selection';
/**
 * The class name added to an editor widget that has a cursor/selection
 * within the whitespace at the beginning of a line
 */

var HAS_IN_LEADING_WHITESPACE_CLASS = 'jp-mod-in-leading-whitespace';
/**
 * RegExp to test for leading whitespace
 */

var leadingWhitespaceRe = /^\s+$/;
/**
 * A widget which hosts a code editor.
 */

var CodeEditorWrapper = /*#__PURE__*/function (_widgets_1$Widget) {
  _inherits(CodeEditorWrapper, _widgets_1$Widget);

  var _super = _createSuper(CodeEditorWrapper);

  /**
   * Construct a new code editor widget.
   */
  function CodeEditorWrapper(options) {
    var _this;

    _classCallCheck(this, CodeEditorWrapper);

    _this = _super.call(this);
    var editor = _this.editor = options.factory({
      host: _this.node,
      model: options.model,
      uuid: options.uuid,
      config: options.config,
      selectionStyle: options.selectionStyle
    });
    editor.model.selections.changed.connect(_this._onSelectionsChanged, _assertThisInitialized(_this));
    return _this;
  }
  /**
   * Get the model used by the widget.
   */


  _createClass(CodeEditorWrapper, [{
    key: "model",
    get: function get() {
      return this.editor.model;
    }
    /**
     * Dispose of the resources held by the widget.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      if (this.isDisposed) {
        return;
      }

      _get(_getPrototypeOf(CodeEditorWrapper.prototype), "dispose", this).call(this);

      this.editor.dispose();
    }
    /**
     * Handle `'activate-request'` messages.
     */

  }, {
    key: "onActivateRequest",
    value: function onActivateRequest(msg) {
      this.editor.focus();
    }
    /**
     * A message handler invoked on an `'after-attach'` message.
     */

  }, {
    key: "onAfterAttach",
    value: function onAfterAttach(msg) {
      _get(_getPrototypeOf(CodeEditorWrapper.prototype), "onAfterAttach", this).call(this, msg);

      if (this.isVisible) {
        this.update();
      }
    }
    /**
     * A message handler invoked on an `'after-show'` message.
     */

  }, {
    key: "onAfterShow",
    value: function onAfterShow(msg) {
      this.update();
    }
    /**
     * A message handler invoked on a `'resize'` message.
     */

  }, {
    key: "onResize",
    value: function onResize(msg) {
      if (msg.width >= 0 && msg.height >= 0) {
        this.editor.setSize(msg);
      } else if (this.isVisible) {
        this.editor.resizeToFit();
      }
    }
    /**
     * A message handler invoked on an `'update-request'` message.
     */

  }, {
    key: "onUpdateRequest",
    value: function onUpdateRequest(msg) {
      this.editor.refresh();
    }
    /**
     * Handle a change in model selections.
     */

  }, {
    key: "_onSelectionsChanged",
    value: function _onSelectionsChanged() {
      var _this$editor$getSelec = this.editor.getSelection(),
          start = _this$editor$getSelec.start,
          end = _this$editor$getSelec.end;

      if (start.column !== end.column || start.line !== end.line) {
        // a selection was made
        this.addClass(HAS_SELECTION_CLASS);
        this.removeClass(HAS_IN_LEADING_WHITESPACE_CLASS);
      } else {
        // the cursor was placed
        this.removeClass(HAS_SELECTION_CLASS);

        if (this.editor.getLine(end.line).slice(0, end.column).match(leadingWhitespaceRe)) {
          this.addClass(HAS_IN_LEADING_WHITESPACE_CLASS);
        } else {
          this.removeClass(HAS_IN_LEADING_WHITESPACE_CLASS);
        }
      }
    }
  }]);

  return CodeEditorWrapper;
}(widgets_1.Widget);

exports.CodeEditorWrapper = CodeEditorWrapper;